<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("add") }} {{ $tc("denomination", 2) }}
      </div>
      <router-link class="btn-blue" to="denominations"
        >{{ $tc("denomination", 2) }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div class="col-lg-6 col-xl-3 align-self-center mb-2">
          <div class="dropdown-curve-container">
            <label :class="selected.country.length > 0 ? 'shift-up' : ''"
              >{{ $tc("country", 1) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selected.country"
                variant="dropdown-curve"
                class="w-100"
                v-b-tooltip.hover
                 :title="$t('denominationcountry_tooltip')"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Country"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCountry($event.target.value)"
                    v-on:keydown="onSearchCountry($event.target.value)"
                    v-on:search="onSearchCountry($event.target.value)"
                    v-model="searchCountry"
                  />
                </div>
                <b-dropdown-item
                  v-for="(country, countryIndex) in Countries"
                  @click="onSelectCountry($event, country)"
                  :key="countryIndex"
                  name="select_country"
                  id="select_country"
                  
                  >{{ country.country_name }}</b-dropdown-item
                >
              </b-dropdown>
              <!-- <Tooltip :title="$t('denominationcountry_tooltip')" /> -->
            </div>
            <p class="error_message">
              <span v-if="submitted && selected.country.length == 0">{{
                messagecountry
              }}</span>
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-3 align-self-center mb-2">
          <div class="dropdown-curve-container">
            <label :class="selected.currency.length > 0 ? 'shift-up' : ''"
              >{{ $tc("currency", 1) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selected.currency"
                variant="dropdown-curve"
                class="w-100"
                v-b-tooltip.hover
               :title="$t('denominationcurreny_tooltip')"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Currency"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCurrency()"
                    v-on:keydown="onSearchCurrency()"
                    v-on:search="onSearchCurrency()"
                    v-model="searchCurrency"
                  />
                </div>
                <b-dropdown-item
                  v-for="(currency, currencyIndex) in Currencies"
                  :key="currencyIndex"
                  @click="onSelectCurrency($event, currency)"
                  name="select_currency"
                  id="select_currency"
                  >{{ currency.curr_name }}</b-dropdown-item
                >
              </b-dropdown>
              <!-- <Tooltip :title="$t('denominationcurreny_tooltip')" /> -->
            </div>
            <p class="error_message">
              <span v-if="submitted && selected.currency.length == 0">{{
                messagecurrency
              }}</span>
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
              style="text-align:right;"
                placeholder="."
                v-model="denominationsObject.denomination_value"
                type="text"
                name="denomination_val"
                id="denomination_val"
                v-validate="'required|decimal'"
                v-b-tooltip.hover
                :title="$t('denominationvalue_tooltip')"
              />
              <!-- v-validate="{required: 'required', regex:'[0-9]||[0-9]*\\.[0-9]*$'}" -->
              <label>{{ $tc("denomination", 1) }} {{ $t("value") }}</label>
            </div>
            <!-- <Tooltip :title="$t('denominationvalue_tooltip')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('denomination_val')">{{
              errors.first("denomination_val")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-2 align-self-center mb-2">
          <div class="d-flex align-items-center">
            
            <b-form-checkbox
              unchecked-value="N"
              v-model="denominationsObject.denomination_is_active"
              value="Y"
              name="check-button"
              class="j-checkbox"            
            ></b-form-checkbox>
            <label class="mb-0 mr-3">{{ $t("active") }}</label> 
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-12 col-xl-12 align-self-center mt-2 text-center">
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(true)"
            class="btn-blue"
          >
            {{ $t("save") }}
          </button>
          <button @click.prevent.stop="onFinalSubmit(false)" class="btn-blue">
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="onResetForm" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="denominations"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
export default {
  data() {
    return {
      CountriesCopy: [],
      CurrencyCopy: [],
      searchCurrency: "",
      searchCountry: "",
      btenable: false,
      messagecountry: "Please select country",
      messagecurrency: "Please select currency",
      submitted: false,
      Countries: [],
      Currencies: [],
      selected: {
        country: "Select Country",
        currency: "Select Currency"
      },
      denominationsObject: {
        country_id: null,
        currency_id: null,
        denomination_value: null,
        denomination_is_active: "Y"
      }
    };
  },
  beforeMount() {
    this.onResetForm();
    this.getCountryList();
    this.getCurrencyList();
  },
  mounted() {},
  methods: {
    onSearchCountry: function(value) {
      if (this.searchCountry && this.searchCountry.length > 0) {
        this.Countries = this.CountriesCopy.filter(x => {
          if (
            x.country_name
              .toLowerCase()
              .includes(this.searchCountry.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Countries = this.CountriesCopy;
      }
    },
    onSearchCurrency: function() {
      if (this.searchCurrency && this.searchCurrency.length > 0) {
        this.Currencies = this.CurrencyCopy.filter(x => {
          if (
            x.curr_name
              .toLowerCase()
              .includes(this.searchCurrency.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Currencies = this.CurrencyCopy;
      }
    },
    getCountryList: function() {
      this.Countries = [];
      let payload = {
        tableName: "ms_countries",
        country_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Countries = data.Records;
            this.CountriesCopy = data.Records;
          } else {
            // Shoe Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          // Catch Error:
          console.log("Catch Error on getActiveScreenByCinemaId :", error);
        });
    },
    getCurrencyList: function() {
      this.Currencies = [];
      let payload = {
        tableName: "ms_currencies",
        curr_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Currencies = data.Records;
            this.CurrencyCopy = data.Records;
          } else {
            // Show Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          // Catch Error:
          console.log("Catch Error on getActiveScreenByCinemaId :", error);
        });
    },
    onSelectCountry: function(event, params) {
      this.selected.country = params.country_name;
      this.denominationsObject.country_id = params.country_id;
      (this.searchCountry = ""), this.onSearchCountry(null);
    },
    onSelectCurrency: function(event, params) {
      this.selected.currency = params.curr_name;
      this.denominationsObject.currency_id = params.curr_id;
    },
    onResetForm: function() {
      this.selected = {
        country: "",
        currency: ""
      };
      this.denominationsObject = {
        country_id: null,
        currency_id: null,
        denomination_value: null,
        denomination_is_active: "Y"
      };
    },
    onFinalSubmit: function(redirect) {
      this.submitted = true;

      this.$validator.validate().then(valid => {
        if (
          this.denominationsObject.country_id == null ||
          this.denominationsObject.currency_id == null
        ) {
          return;
        }
        if (valid) {
          this.btenable = true;
          MasterService.AddDenomination(this.denominationsObject)
            .then(response => {
              this.btenable = false;
              const { data } = response;
              if (data && data.status) {
                this.onResetForm();
                if (redirect) {
                  this.$router.push({
                    path: "/master/denominations"
                  });
                }
              } else {
                // Show Error Message:
                this.$toasted.show(data.message);
                console.log("data.message :", data.message);
              }
            })
            .catch(error => {
              // Catch Error:
              console.log("Catch Error On onFinalSubmit :", error);
            });
        }
      });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/DenominationsComponents/addDenomination.vue